// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"xvdFaYX","volumeControl":"xvdFaYX","on":"ORYm4aW","off":"m7IKFwB"};